module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-6.fe251698.png";